import { Component, inject, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatToolbarModule } from '@angular/material/toolbar';
import { firstValueFrom, Observable, Subject } from 'rxjs';
import { LoadingService } from '../../loading/loading.service';
import { iEntrada } from '../entrada.interface';
import { EntradaService } from '../entrada.service';
import { ActivatedRoute } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { AppState } from '../../app.state';
import { selectEntrada } from '../../states/entrada/selector';
import { CommonModule } from '@angular/common';
import { cargaEntradaCampos } from '../../states/entrada/actions';
import moment from 'moment';

@Component({
  selector: 'app-add-edit-registros-relacionados',
  standalone: true,
  imports: [
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatFormFieldModule,
    FormsModule,
    CommonModule
  ],
  templateUrl: './add-edit-registros-relacionados.component.html',
  styleUrl: './add-edit-registros-relacionados.component.css'
})
export class AddEditRegistrosRelacionadosComponent {
  private active = inject(ActivatedRoute);
  private loadingService = inject(LoadingService);
  private entradaService = inject(EntradaService);
  private readonly store: Store<AppState> = inject(Store);
  private readonly stateEntrada: any = this.store.pipe(select(selectEntrada));
  private idEntrada = this.active.snapshot.params['id'];
  private idTema = this.active.snapshot.params['tema'];

  @Input() listenToFather!: Observable<boolean>;
  @Output() sendToFather: Subject<any> = new Subject();

  public oEntrada: iEntrada;
  public listaRelacionados: any = {
    padre: [],
    hijos: [],
    hermanos: []
  };
  
  constructor() {
    this.oEntrada = structuredClone(this.stateEntrada.state().entrada);
  }

  async ngOnInit() {
    this.loadingService.show();
    
    ///////////////////////////// ONCHANGE BUSINESS RULES //////////////////////////////
    if(this.idEntrada != 'add') {
      this.listaRelacionados = await firstValueFrom(this.entradaService.obtenerRelacionados(this.idEntrada, this.oEntrada.idPadre??=''));
      this.store.dispatch(cargaEntradaCampos({ oData: {'relacionados': this.listaRelacionados} }));
    }
    ////////////////////////////////////////////////////////////////////////////////////
    this.loadingService.hide();
  }

  getStatus (item: any) {
    return moment().isAfter(item.end) && item.status != "Terminado"?"VENCIDO": item.status.toUpperCase();
  };
}